export const TENANT_MAPPER_JRPC_IDENTIFIER = 'TENANT_MAPPER_JRPC_IDENTIFIER';
